import { render } from "./Card.vue?vue&type=template&id=2f05f758&bindings={}"
import script from "./Card.vue?vue&type=script&lang=ts"
export * from "./Card.vue?vue&type=script&lang=ts"

import "./Card.vue?vue&type=style&index=0&lang=css"
script.render = render

export default script